// extracted by mini-css-extract-plugin
export default {"form":"copyImageInMultipleImageAnnotationToImageAnnotationGroup_form__vPApv"};